import { useMemo } from "react";

export default function Table({
  TableHead,
  TableData,
  icon,
  header,
  tableRef,
  tableRowStyle,
  thStyle,
  tbodyStyle,
  trStyle,
  tdStyle,
  containerStyle,
  tableStyle,
}) {
  const allKeysPresent = useMemo(
    () =>
      TableHead.every((header) =>
        TableData?.every((dataItem) =>
          Object.keys(dataItem)
            .map((el) => el.toLowerCase())
            .includes(header.accessorKey.toLowerCase())
        )
      ),
    [TableHead, TableData]
  );

  if (!allKeysPresent) {
    throw new Error(
      "Table data does not contain all required accessor keys of headers or table data objects don't have the same keys. Check data and headers arrays !"
    );
  }

  return (
    <>
      <div
        className={` rounded-2xl p-4 bg-white  shadow-mainShadow max-w-[1000px] mx-auto w-full ${containerStyle}`}
      >
        <h3 className="flex items-center gap-2 p-4 text-xl font-bold text-mainBlue">
          <span>{icon}</span>
          <span>{header}</span>
        </h3>
        <table
          className={` px-4 leading-normal custom_table w-full ${tableStyle}`}
          ref={tableRef}
        >
          <thead
            className={
              "w-full border-none rounded-lg whitespace-nowrap bg-[#F9FAFB]  text-mainRed"
            }
          >
            <tr className={`${tableRowStyle}`}>
              {TableHead?.map((item, i) => (
                <th key={i} className={`p-4 font-normal ${thStyle}`}>
                  {item.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className={`${tbodyStyle}`}>
            {TableData?.map((row, rowIndex) => (
              <tr key={rowIndex} className={`${trStyle}`}>
                {TableHead.map((head, colIndex) => (
                  <td
                    key={colIndex}
                    className={`text-center text-mainGray py-4 ${tdStyle}`}
                  >
                    {head.accessorKey === "image" && row[head.accessorKey] ? (
                      <div className="flex items-center justify-center ">
                        <img
                          alt="img"
                          src={row[head.accessorKey]}
                          width={50}
                          height={50}
                          className="rounded-full size-[50px] object-cover"
                        />
                      </div>
                    ) : (
                      row[head.accessorKey] ?? ""
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
